import { Table, TABLES, canEnter, settleHand } from '../engine/economy';

export interface Wallet {
  balance: number;
  lastDailyDate: string | null; // 마지막 데일리 보너스 수령일 'YYYY-MM-DD'
}

export const STARTING_MONEY = 30000;
export const DAILY_BONUS = 5000;

export function createWallet(): Wallet {
  return { balance: 0, lastDailyDate: null };
}

/** 튜토리얼 완료 보상. */
export function grantStartingMoney(w: Wallet): Wallet {
  return { ...w, balance: w.balance + STARTING_MONEY };
}

/** 한 판 정산을 지갑에 반영(불변). */
export function applyHandResult(w: Wallet, pointDelta: number, table: Table): Wallet {
  return { ...w, balance: settleHand(w.balance, pointDelta, table) };
}

export function canClaimDaily(w: Wallet, today: string): boolean {
  return w.lastDailyDate !== today;
}

export function claimDaily(w: Wallet, today: string): Wallet {
  if (!canClaimDaily(w, today)) return w;
  return { ...w, balance: w.balance + DAILY_BONUS, lastDailyDate: today };
}

export function unlockedTables(w: Wallet): Table[] {
  return TABLES.filter((t) => canEnter(w.balance, t));
}

// ── localStorage 어댑터(얇은 격리, 브라우저 없으면 안전) ──
const STORAGE_KEY = 'majak.wallet';

export function loadWallet(): Wallet {
  try {
    if (typeof localStorage === 'undefined') return createWallet();
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return createWallet();
    const parsed = JSON.parse(raw) as Partial<Wallet>;
    return {
      balance:
        Number.isFinite(parsed.balance) && (parsed.balance as number) >= 0
          ? (parsed.balance as number)
          : 0,
      lastDailyDate: typeof parsed.lastDailyDate === 'string' ? parsed.lastDailyDate : null,
    };
  } catch {
    return createWallet();
  }
}

export function saveWallet(w: Wallet): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(w));
  } catch {
    /* 영속 실패는 조용히 무시 */
  }
}
